<template>
  <nav :class="['sidebar', { collapsed: !isSidebarOpen }]">
    <div class="sidebar-header">
      <h3 v-if="isSidebarOpen">Navigation</h3>
      <button @click="togglePanel" class="btn btn-panel">
        <i :class="isSidebarOpen ? 'fa-solid fa-chevron-left' : 'fa-solid fa-chevron-right'"></i>
      </button>
    </div>

    <ul v-if="isSidebarOpen">
      <li :class="{active: page === 'dashboard'}" @click="navigate('dashboard')">
        <i class="fa-light fa-house"></i>Dashboard
      </li>
      <li :class="{active: page === 'simulation'}" @click="navigate('simulation')">
        <i class="fa-light fa-server"></i>API Simulation
      </li>
    </ul>

    <ul v-else>
      <li :class="{active: page === 'dashboard'}" @click="navigate('dashboard')" title="Dashboard">
        <i class="fa-light fa-house"></i>
      </li>
      <li :class="{active: page === 'simulation'}" @click="navigate('simulation')">
        <i class="fa-light fa-server"></i>
      </li>
    </ul>

    <span v-if="isSidebarOpen">Reconciliation</span>

    <ul v-if="isSidebarOpen">
      <li :class="{active: page === 'vibanmanagement'}" @click="navigate('vibanmanagement')">
        <i class="fa-light fa-database"></i>VIBAN Management
      </li>
      <li :class="{active: page === 'reconciliationledger'}" @click="navigate('reconciliationledger')">
        <i class="fa-light fa-user-check"></i>Reconciliation Ledger
      </li>
      <li :class="{active: page === 'transactionledger' || page.startsWith('/transactionledger')}" @click="navigate('transactionledger')">
        <i class="fa-light fa-file-magnifying-glass"></i>Transaction Ledger
      </li>
      <li :class="{active: page === 'dailyreport'}" @click="navigate('dailyreport')">
        <i class="fa-light fa-calendar-check"></i>Daily Report
      </li>
    </ul>

    <span v-if="isSidebarOpen">Configuration</span>

    <ul v-if="isSidebarOpen">
      <li :class="{active: page === 'configuration'}" @click="navigate('configuration')">
        <i class="fa-light fa-wave-pulse"></i>Reconciliation Rules
      </li>
      <li :class="{active: page === 'usermanagement'}" @click="navigate('usermanagement')">
        <i class="fa-light fa-user-group"></i>User Management
      </li>
      <li :class="{active: page === 'auditlogs'}" @click="navigate('auditlogs')">
        <i class="fa-light fa-file-magnifying-glass"></i>Audit Logs
      </li>
    </ul>

    <span v-if="isSidebarOpen">Help</span>

    <ul v-if="isSidebarOpen">
      <li :class="{active: page === 'documentation'}" @click="navigate('documentation')">
        <i class="fa-light fa-book-open"></i>Documentation
      </li>
    </ul>

    <ul v-else>
      <li v-for="item in collapsedItems" :key="item.page" :class="{ active: page === item.page }" @click="navigate(item.url)" :title="item.label">
        <i :class="['fa-light', item.icon]"></i>
      </li>
    </ul>

    <div v-if="isSidebarOpen" class="stats">
      <div class="stats-title">
        <h1>Quick Stats</h1>
      </div>
      <div><span>Automation Rate:</span><span>{{ stats.AutomationRate.toFixed(2) }}%</span></div>
      <div><span>Overdue Orders:</span><span>{{ stats.NbOverdue }}</span></div>
      <div><span>Today's Volume:</span><span>€{{ stats.AmountReconciliation.toFixed(2) }}</span></div>
      <div><span>Today's Reconciliations:</span><span>{{ stats.NbReconciliation }}</span></div>
      <div><span>Active Rule Config:</span><span>E-commerce Standard</span></div>
    </div>
  </nav>
</template>

<script>
  import {loadPage} from '@/helpers/routing'
  export default {
    name: 'LeftPanel',
    props: {
      isSidebarOpen: {
      type: Boolean,
      default: true
      },
      stats: {
        type: Object
      }
    },
    data (){
      return {
        page: "dashboard"
      }
    },
    computed: {
      collapsedItems() {
        return [
          { page: 'vibanmanagement', icon: 'fa-database', url: 'vibanmanagement', label: 'VIBAN Management' },
          { page: 'reconciliationledger', icon: 'fa-user-check', url: 'reconciliationledger', label: 'Reconciliation Ledger' },
          { page: 'transactionledger', icon: 'fa-file-magnifying-glass', url: 'transactionledger', label: 'Transaction Ledger' },
          { page: 'dailyreport', icon: 'fa-calendar-check', url: 'dailyreport', label: 'Daily Report' },
          { page: 'configuration', icon: 'fa-wave-pulse', url: 'configuration', label: 'Configuration' },
          { page: 'usermanagement', icon: 'fa-user-group', url: 'usermanagement', label: 'User Management' },
          { page: 'auditlogs', icon: 'fa-file-magnifying-glass', url: 'auditlogs', label: 'Audit Logs' },
          { page: 'documentation', icon: 'fa-book-open', url: 'documentation', label: 'Documentation' }
        ]
      }
    },
    emits: ['update:isSidebarOpen'],
    methods: {
      togglePanel() {
        this.$emit('update:isSidebarOpen', !this.isSidebarOpen)
      },
      navigate(url){
        this.page = url
        loadPage(this, {url: '/' + url + '/' + (this.page == 'transactionledger' ? null : '')})
      }
    }
  }
</script>

<style scoped>
/*  sidebar  */

.sidebar {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 18%;
  padding: 1rem 0;
  background-color: #fff;
  border-right: 1px solid #0000001a;
  overflow: scroll;
  z-index: 1;
  transition: width 0.3s ease;
}

.sidebar::-webkit-scrollbar {
    display: none;
}

.sidebar.collapsed {
  width: 60px;
}

/*  header  */

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10%;
}

.sidebar-header h3 {
  font-weight: normal;
  font-size: 1.5rem;
  color: #0000009f;
}

/*  buttons  */

.btn-panel {
  padding: 0.5rem 1rem;
}

.btn-panel:hover {
  background-color: #e9ebef;
}

/*  sections  */

.sidebar > span {
  display: block;
  padding: 0 10%;
  color: #0000009f;
  margin-top: 1rem;
}

/*  navigation  */

.sidebar ul {
  padding: 0 10%;
  width: 100%;
}

.sidebar li {
  display: flex;
  align-items: center;
  gap: 1rem;
  height: 3rem;
  margin: 0.5rem 0;
  padding: 1rem;
  font-weight: bold;
  border-radius: calc(0.625rem - 2px);
  cursor: pointer;
}

.sidebar li i {
  font-size: 1.2rem;
}

.sidebar li:hover:not(.active) {
  background-color: #e9ebef;
}

.active {
  background-color: #030213;
  color: #fff;
}

/*  stats  */

.stats {
  position: relative;
  bottom: 0;
  width: 100%;
  padding: 0 1rem;
  background-color: #f8f9fa;
  border-top: 1px solid #0000001a;
}

.stats-title h1 {
  font-size: 1rem;
  color: #6a7282;
  margin: 1rem 0;
}

.stats > div {
  display: flex;
  justify-content: space-between;
  margin: 0.75rem 0;
}

</style>